export default {
  loadBefore: '查看原图',
  loadStart: '加载中',
  loadEnd: '加载完成'
};